export const GET_JOB_ASSIGNMENTS = `
  query GetJobAssignments($where: job_assignments_bool_exp = {}, $limit: Int, $offset: Int, $order_by: [job_assignments_order_by!] = [{ created_at: desc }]) {
    job_assignments_aggregate(where: $where) {
      aggregate { count }
    }
    job_assignments(where: $where, order_by: $order_by, limit: $limit, offset: $offset) {
      id
      job_id
      company_id
      technical_team_id
      technical_user_id
      financial_team_id
      financial_user_id
      assigned_by
      created_at
      company {
        id
        name
      }
      technical_team {
        id
        name
      }
      technical_user {
        id
        first_name
        last_name
        work_end_date
      }
      financial_team {
        id
        name
      }
      financial_user {
        id
        first_name
        last_name
      }
      assigned_by_user {
        id
        first_name
        last_name
      }
      job {
        id
        job_title
        project_number
        consulting_scope
        job_type
        job_type_obj: job_type_rel { id name }
        job_status
        created_by
        user {
          id
          first_name
          last_name
        }
        no_financial_needed
        created_at
        updated_at
        company {
          id
          name
        }
        firm {
          id
          firm_name
          firm_short_name
        }
      }
    }
  }
`;

export const GET_JOB_ASSIGNMENT_BY_ID = `
  query GetJobAssignmentById($id: Int!) {
    job_assignments_by_pk(id: $id) {
      id
      job_id
      company_id
      technical_team_id
      technical_user_id
      financial_team_id
      financial_user_id
      assigned_by
      created_at
      company {
        id
        name
      }
      technical_team {
        id
        name
      }
      technical_user {
        id
        first_name
        last_name
        work_end_date
      }
      financial_team {
        id
        name
      }
      financial_user {
        id
        first_name
        last_name
      }
      assigned_by_user {
        id
        first_name
        last_name
      }
      job {
        id
        job_title
        project_number
        job_type
        job_type_obj: job_type_rel { id name }
        job_status
        created_by
        updated_at
        user {
          id
          first_name
          last_name
        }
        company {
          id
          name
        }
        firm {
          id
          firm_name
          firm_short_name
        }
      }
    }
  }
`;

// ROOT / DIRECTOR / GROUP_MANAGER için tüm şirket atanmamış işleri.
export const GET_UNASSIGNED_JOBS = `
  query GetUnassignedJobs($companyId: Int!) {
    jobs(
      where: {
        company_id: { _eq: $companyId },
        _or: [
          { job_assignment_id: { _is_null: true } },
          {
            job_status: { _eq: ONAYLANDI },
            consulting_scope: { _neq: SADECE_TEKNIK },
            no_financial_needed: { _eq: false },
            job_assignment: { financial_user_id: { _is_null: true } }
          }
        ]
      },
      order_by: { created_at: desc }
    ) {
      id
      job_title
      job_type
      job_type_obj: job_type_rel { id name }
      job_status
      project_number
      consulting_scope
      no_financial_needed
      created_at
      description_of_job
      created_by
      user {
        id
        first_name
        last_name
      }
      company {
        id
        name
      }
      firm {
        id
        firm_name
        firm_short_name
        firm_city
        description
        luca_code
        is_established
        firm_partners { partner { id partner_name } }
        firm_sectors { sector { id sector_name } }
      }
      contract {
        id
        contract_subject {
          id
          name
          is_project_based
        }
        scope_of_work {
          id
          name
        }
        contract_signing_date
        work_start_date
        pricing_method {
          id
          name
        }
        firm {
          id
          firm_name
          firm_short_name
        }
      }
      job_assignment_id
      job_assignment {
        id
        technical_team_id
        technical_user_id
        financial_team_id
        financial_user_id
        technical_team {
          id
          name
        }
        technical_user {
          id
          first_name
          last_name
          work_end_date
        }
        financial_team {
          id
          name
        }
        financial_user {
          id
          first_name
          last_name
        }
      }
    }
  }
`;

// Restricted roller (TEAM_MEMBER / TEAM_MANAGER) için: sadece kullanıcının
// kendi yarattığı atanmamış işler. Amaç: kullanıcı oluşturduğu işi
// görebilsin ve "oluşmadı sandım" diye duplicate açmasın; ROOT'un atama
// yapmasını beklesin. created_by = user.id filter'i ek olarak gelir.
export const GET_UNASSIGNED_JOBS_FOR_CREATOR = `
  query GetUnassignedJobsForCreator($companyId: Int!, $userId: Int!) {
    jobs(
      where: {
        company_id: { _eq: $companyId },
        created_by: { _eq: $userId },
        _or: [
          { job_assignment_id: { _is_null: true } },
          {
            job_status: { _eq: ONAYLANDI },
            consulting_scope: { _neq: SADECE_TEKNIK },
            no_financial_needed: { _eq: false },
            job_assignment: { financial_user_id: { _is_null: true } }
          }
        ]
      },
      order_by: { created_at: desc }
    ) {
      id
      job_title
      job_type
      job_type_obj: job_type_rel { id name }
      job_status
      project_number
      consulting_scope
      no_financial_needed
      created_at
      description_of_job
      company { id name }
      firm {
        id
        firm_name
        firm_short_name
        firm_city
        description
        luca_code
        is_established
        firm_partners { partner { id partner_name } }
        firm_sectors { sector { id sector_name } }
      }
      contract {
        id
        contract_subject { id name is_project_based }
        scope_of_work { id name }
        contract_signing_date
        work_start_date
        pricing_method { id name }
        firm { id firm_name firm_short_name }
      }
      job_assignment_id
      job_assignment {
        id
        technical_team_id
        technical_user_id
        financial_team_id
        financial_user_id
        technical_team { id name }
        technical_user { id first_name last_name work_end_date }
        financial_team { id name }
        financial_user { id first_name last_name }
      }
    }
  }
`;
